import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XRefProvider, useReferences } from '@myst-theme/providers';
import { select } from 'unist-util-select';
import { HoverPopover } from './components/index.js';
import { MyST } from './MyST.js';
function FootnoteDefinition({ identifier }) {
    var _a, _b;
    const references = useReferences();
    const node = (_b = (_a = references === null || references === void 0 ? void 0 : references.footnotes) === null || _a === void 0 ? void 0 : _a[identifier]) !== null && _b !== void 0 ? _b : select(`footnoteDefinition[identifier=${identifier}]`, references === null || references === void 0 ? void 0 : references.article);
    return (_jsx(XRefProvider, { children: _jsx("div", { className: "hover-document article w-[500px] sm:max-w-[500px] px-3", children: _jsx(MyST, { ast: node.children }) }) }));
}
export const FootnoteReference = ({ node }) => {
    var _a;
    return (_jsx(HoverPopover, { openDelay: 0, card: _jsx(FootnoteDefinition, { identifier: node.identifier }), children: _jsx("span", { children: _jsxs("sup", { className: "hover-link", children: ["[", (_a = node.number) !== null && _a !== void 0 ? _a : node.identifier, "]"] }) }) }));
};
const FOOTNOTE_RENDERERS = {
    footnoteReference: FootnoteReference,
    // Do not render the definitions, they get pulled in by a handler
    footnoteDefinition: () => null,
};
export default FOOTNOTE_RENDERERS;
